<template>
    <div>
        <DefaultTemplate
            title=""
            subtitle=""
            :steps="false"
        >
           <Changelog />
        </DefaultTemplate>
    </div>
</template>
<script>
import DefaultTemplate from "@/template/DefaultTemplate.vue";
import Changelog from "@/components/Changelog.vue";
export default {
    name: "changLog",
    components: {
        DefaultTemplate,
        Changelog
    }
}
</script>
<style scoped>

</style>
